export default {
  items: [{
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Manage Users',
      url: '/manage-users',
      icon: 'cui-people',
      children: [{
          name: 'Users',
          url: '/manage-users/users',
          permissions: ['manage-users'],
        },
        {
          name: 'Roles',
          url: '/manage-users/roles',
          permissions: ['manage-roles'],
        }
      ]
    },
    {
      name: 'Manage Gate Entry',
      url: '/manage-gate-entry',
      icon: 'cui-calendar',
      children: [{
        name: 'Gate Security',
        url: '/manage-gate-entry/gate-security',
        permissions: ['gate-reservations-obsolete'],
    },
    {
      name: 'Gate Visitor Entry',
      url: '/manage-gate-entry/gate-visitor-entry',
      permissions: ['gate-visitor-entry'],
  },

  {
    name: 'Pending Visitors Report',
    url: '/manage-gate-entry/gate-pending-visitors',
    permissions: ['gate-pending-visitor'],
  },

  {
    name: 'Exit Scan Ticket',
    url: '/manage-gate-entry/gate-exit-status',
    permissions: ['gate-pending-visit-status-update'],
  },
  {
    name: 'Non Satsangi Visitors Report',
    url: '/manage-gate-entry/gate-non-satsangi-visitors',
    permissions: ['gate-non-satsangi-visitors'],
  },

  
  
      ]
    },
    {
      name: 'Dictionary',
      url: '/dictionary',
      icon: 'cui-calendar',
      children: [{
        name: 'Dictionary',
        url: '/dictionary',
        }] 
    },       
    {
      name: 'Manage Reservations',
      url: '/manage-reservations',
      icon: 'cui-calendar',
      children: [{
          name: 'Reservations',
          url: '/manage-reservations/reservations',
          permissions: ['manage-reservations'],
        },        
        {
          name: 'Gate Check In',
          url: '/manage-reservations/gate-reservations',
          permissions: ['gate-reservations'],
      },
      {
        name: 'Accomodation Check In',
        url: '/manage-reservations/accomodation-reservations',
        permissions: ['acco-checkin', 'print-bhandarghar-ticket'],
    },
        {
            name: 'Bhent',
            url: '/manage-reservations/payments',
            permissions: ['bhent'],
        },
        {
          name: 'Admin Booking',
          url: '/manage-reservations/admin-booking',
          permissions: ['admin-booking'],
        },
        {
          name: 'Satsangi Booking',
          url: '/accomodation',
        },
        {
          name: 'Manual Room Allocation',
          url: '/manage-reservations/manual-reservation',
          permissions: ['visitor-report'],
        }
      ]
    },
    {
      name: 'Manage Buildings',
      url: '/manage-buildings',
      icon: 'cui-home',
      children: [{
          name: 'Buildings',
          url: '/manage-buildings/buildings',
          permissions: ['manage-buildings'],
        },
        {
          name: 'Attributes',
          url: '/manage-buildings/attributes',
          permissions: ['manage-attributes'],
        }
      ]
    },
    {
      name: 'Soamibagh Office',
      url: '/office',
      icon: 'cui-home',
      children: [{
          name: 'Office Pos',
          url: '/office/pos',
          permissions: ['office-pos'],
        },
        {
            name: 'Categories',
            url: '/office/categories',
            permissions: ['office-categories'],
        },
        {
            name: 'Products',
            url: '/office/products',
            permissions: ['office-products'],
        },
      ]
    },
    {
      name: 'Bookcentre',
      url: '/bookcentre',
      icon: 'cui-home',
      children: [{
          name: 'Bookcentre Pos',
          url: '/bookcentre/pos',
          permissions: ['bookcentre-pos'],
        },
        {
            name: 'Categories',
            url: '/bookcentre/categories',
            permissions: ['bookcentre-categories'],
        },
        {
            name: 'Products',
            url: '/bookcentre/products',
            permissions: ['bookcentre-products'],
        },
        {
          name: 'Low Inventory Report',
          url: '/bookcentre/low-inventory-report',
          permissions: ['bookcentre-low-inventory-report'],
      },
      {
        name: 'Sale By Date',
        url: '/bookcentre/sale-by-date',
        permissions: ['bookcentre-sale-report'],
    },
      ]
    },
    {
      name: 'BhandarGhar',
      url: '/bhandarghar',
      icon: 'cui-home',
      children: [{
          name: 'Bhandarghar Pos',
          url: '/bhandarghar/pos',
          permissions: ['bhandarghar-pos'],
        },
        {
            name: 'Categories',
            url: '/bhandarghar/categories',
            permissions: ['bhandarghar-categories'],
        },
        {
            name: 'Products',
            url: '/bhandarghar/products',
            permissions: ['bhandarghar-products'],
        },
        {
            name: 'Devices',
            url: '/bhandarghar/devices',
            permissions: ['bhandarghar-devices'],
        },      
      ]
    },
    {
      name: 'Dispensary',
      url: '/dispensary',
      icon: 'cui-home',
      children: [{
          name: 'Patient Entry Form',
          url: '/dispensary/entryform',
          permissions: ['patient-entry-form'],
        },
      ]
    },
    {
      name: 'Vaccination',
      url: '/vaccination',
      icon: 'cui-home',
      children: [{
          name: 'Vaccination Entry Form',
          url: '/vaccination/entryform',
          permissions: ['vaccination-entry-form'],
        },
        {
            name: 'Vaccination List',
            url: '/vaccination/listform',
            permissions: ['vaccination-entry-form'],
        },
      ]
    },
    {
      name: 'Electrical',
      url: '/electrical',
      icon: 'cui-chart',
      children: [
        {
          name: 'Satsangi Profiles',
          url: '/electrical/profiles',
          permissions: ['electrical-profiles'],
        },
        {
          name: 'Monthly Readings',
          url: '/electrical/bulk-readings',
          permissions: ['electrical-bulk-readings'],
        },
        {
          name: 'Edit Reading',
          url: '/electrical/single-reading',
          permissions: ['electrical-single-reading'],
        },
        {
          name: 'Bhaint Types',
          url: '/electrical/bhaint-types',
          permissions: ['electrical-bhaint-types'],
        },
        {
          name: 'Electric Lines ',
          url: '/electrical/electric-lines',
          permissions: ['electrical-electric-lines'],
        },
        {
          name: 'Reports',
          url: '/electrical/reports',
          icon: 'cui-chart',
          children: [
            {
              name: 'Overdues',
              url: '/electrical/reports/overall-overdues',
              permissions: ['electrical-overall-overdues'],
            },
            {
              name: 'Overdues By Groups',
              url: '/electrical/reports/group-overdues',
              permissions: ['electrical-group-overdues'],
            },
            {
              name: 'Overdues By Periods',
              url: '/electrical/reports/periods-overdues',
              permissions: ['electrical-periods-overdues'],
            },
            {
              name: 'Daily Collection',
              url: '/electrical/reports/daily-collection',
              permissions: ['electrical-daily-collection'],
            },
            {
              name: 'Electric Lines',
              url: '/electrical/reports/electric-lines',
              permissions: ['electrical-lines-load'],
            }
          ]
        }
      ]
    },
    {
      name: 'Samadh',
      url: '/samadh',
      icon: 'cui-chart',
      children: [
        {
          name: 'AadharCard Entry',
          url: '/samadh/aadharcard-scanner',
          permissions: ['samadh-aadharcard-entry'],
        },
        {
          name: 'Security Check',
          url: '/samadh/security-check',
          permissions: ['samadh-security-check'],
        },
        {
          name: 'Exit Point',
          url: '/samadh/exit-point',
          permissions: ['samadh-exit-point'],
        },
        {
          name: 'Visit Hours',
          url: '/samadh/visit-hours',
          permissions: ['samadh-visit-hours'],
        },
        {
          name: 'Reports',
          url: '/samadh/reports',
          icon: 'cui-chart',
          children: [
            {
              name: 'Pending Visitors',
              url: '/samadh/reports/pending-visitors',
              permissions: ['samadh-pending-visitors'],
            },
            {
              name: 'Visitors Entry',
              url: '/samadh/reports/visitors-entry-report',
              permissions: ['samadh-visitors-entry-report'],
            },
            {
              name: 'Visitors Information',
              url: '/samadh/reports/visitors-information-report',
              permissions: ['samadh-visitors-information-report'],
            },
          ]

        },
      ]
    },
    {
      name: 'Reports',
      url: '/reports',
      icon: 'cui-chart',
      children: [
        {
          name: 'Occupancy Report',
          url: '/reports/occupancy-by-range',
          permissions: ['occupancy-report'],
        },
        {
          name: 'Occupancy Overview',
          url: '/reports/occupancy-overview',
          permissions: ['occupancy-overview'],
        },
        {
          name: 'Bhent Received Report',
          url: '/reports/revenue-by-range',
          permissions: ['bhent-received-report'],
        },
        {
          name: 'Bhandara/Satsang',
          url: '/reports/event',
          permissions: ['event-report'],
        },
        {
          name: 'Satsangi Arrival Report',
          url: '/reports/satsangi-arrival-report',
          permissions: ['satsangi-arrival-report'],
        },
        {
          name: 'Visitors Report',
          url: '/reports/visitors-by-range',
          permissions: ['visitor-report'],
        },
        {
          name: 'Gate Entries By Dates',
          url: '/reports/gate-entries-report',
          permissions: ['gate-entries-report'],
        },
        {
          name: 'List Gate Entries',
          url: '/reports/list-gate-entries',
          permissions: ['gate-entries-report'],
        }


      ]
    },
  ]
}
